import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgOrgWallet = function SvgOrgWallet(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_66_24750",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_66_24750)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_66_24750)",
        fillOpacity: 0.16,
        d: "M21.949 70.667q-1.921 0-3.269-1.347-1.347-1.347-1.347-3.269V21.95q0-1.921 1.347-3.269 1.347-1.347 3.269-1.347H66.05q1.921 0 3.269 1.347 1.347 1.347 1.347 3.269V66.05q0 1.921-1.347 3.269-1.347 1.347-3.269 1.347z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_66_24750)",
        fillRule: "evenodd",
        d: "M14.68 65.32q1.347 1.347 3.269 1.347H62.05q1.921 0 3.269-1.347 1.347-1.347 1.347-3.269V17.95q0-1.921-1.347-3.269-1.347-1.347-3.269-1.347H17.95q-1.921 0-3.269 1.347-1.347 1.347-1.347 3.269V62.05q0 1.921 1.347 3.269m40.576-1.217h6.795q.77 0 1.41-.641.642-.642.642-1.41V17.948q0-.77-.641-1.41-.642-.642-1.41-.642H17.948q-.77 0-1.41.641-.642.642-.642 1.41v44.103q0 .77.641 1.41.642.642 1.41.642H25V26.667h30.256zm-2.564 0V29.23H27.564v34.872h5.77V53.974h13.608v10.129zm-8.314 0v-7.564h-8.48v7.564zM37.436 48.59h-4.103v-4.103h4.103zm0-9.487h-4.103V35h4.103zm9.487 9.487h-4.102v-4.103h4.102zm0-9.487h-4.102V35h4.102z",
        clipRule: "evenodd"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_66_24750",
        x1: 17.89,
        x2: 69.924,
        y1: 43.999,
        y2: 43.999,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_66_24750",
        x1: 13.89,
        x2: 65.924,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgOrgWallet as ReactComponent };
//# sourceMappingURL=OrgWallet.svg.es.js.map
